/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.addEventListener("DOMContentLoaded", function () {
//     if (window.location.pathname === "/cart") {
//       var authorityToLeave = document.getElementById("miniAuthorityToLeave");
//       var signOfDelivry = document.getElementById("miniSignOfDelivry");
//       var noteTextarea = document.querySelector('textarea[name="miniVisibleNote"]');
//       var hiddenInput = document.querySelector('input[name="note"]');
//       var noteLength = document.getElementById("mini-cart-order-note-length");
//       if (noteTextarea) {
//         noteTextarea.addEventListener("input", _saveNoteDebounced.bind(this));
//       }
//       if (authorityToLeave) {
//         authorityToLeave.addEventListener(
//           "change",
//           _saveNoteDebounced.bind(this)
//         );
//       }
//       if (signOfDelivry) {
//         signOfDelivry.addEventListener("change", _saveNoteDebounced.bind(this));
//       }
//       var len =
//         (noteTextarea && noteTextarea.value && noteTextarea.value.length) || 0;
//       if (noteLength) {
//         noteLength.innerText = len;
//       }
//       if (hiddenInput && hiddenInput.value === "ATL:") {
//         authorityToLeave.setAttribute("checked", "checked");
//         _saveNoteDebounced();
//       }
  
//       var debounceTimer;
//       function _saveNoteDebounced() {
//         const selectedRadio = document.querySelector(
//           'input[name="miniNoteOption"]:checked'
//         );
//         hiddenInput.value =
//           (selectedRadio ? selectedRadio.value + ":" : "") + noteTextarea.value;
//         var noteValue = hiddenInput.value;
//         console.log('noteValue: ', noteValue);
//         var len = noteTextarea.value.length;
//         noteLength.innerText = len;
//         clearTimeout(debounceTimer);
//         debounceTimer = setTimeout(
//           function () {
//             console.log('save note debounced');
//             fetch("".concat(window.routes.cartUrl, "/update.js"), {
//               body: JSON.stringify({
//                 note: noteValue,
//               }),
//               credentials: "same-origin",
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//                 "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
//               },
//             });
//           }.bind(this),
//           50
//         ); // 500毫秒作为防抖延迟时间，你可以根据需要调整
//       }
//     }
//   });
  document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
      // mini cart delivery instructions
      var miniAuthorityToLeave = document.getElementById("miniAuthorityToLeave");
      var miniSignOfDelivry = document.getElementById("miniSignOfDelivry");
      var miniPickup = document.getElementById("miniPickup");
      var miniNoteTextarea = document.querySelector(
        'textarea[name="miniVisibleNote"]'
      );

        
      if (miniNoteTextarea) {
        miniNoteTextarea.addEventListener(
          "input",
          _saveminiCartNoteDebounced.bind(this)
        );
      }
      if (miniAuthorityToLeave) {
        miniAuthorityToLeave.addEventListener(
          "change",
          _saveminiCartNoteDebounced.bind(this)
        );
      }
      if (miniSignOfDelivry) {
        miniSignOfDelivry.addEventListener(
          "change",
          _saveminiCartNoteDebounced.bind(this)
        );
      }
      if (miniPickup) {
        // hide textarea when pickup is checked
       miniPickup.addEventListener("change",
        _saveminiCartNoteDebounced.bind(this)
       );
      }

      var miniHiddenInput = document.querySelector('input[name="note"]');
      var miniNoteLength = document.getElementById("mini-cart-order-note-length");
      var cartRecapNoteInnerContent = document.getElementById("cart-recap__note-inner-content");
      var miniCartlen =
        (miniNoteTextarea &&
          miniNoteTextarea.value &&
          miniNoteTextarea.value.length) ||
        0;
      if (miniNoteLength) {
        miniNoteLength.innerText = miniCartlen;
      }
      if (miniHiddenInput && miniHiddenInput.value === "ATL:") {
        miniAuthorityToLeave.setAttribute("checked", "checked");
        _saveminiCartNoteDebounced();
      }
      var miniDebounceTimer;
      function _saveminiCartNoteDebounced() {
        const miniSelectedRadio = document.querySelector(
          'input[name="miniNoteOption"]:checked'
        );
        
          if(miniSelectedRadio){
              cartRecapNoteInnerContent.classList.toggle("hidden", miniSelectedRadio.value === 'pickup');
              if(miniSelectedRadio.value === 'pickup'){
                miniNoteTextarea.value = '';
                miniHiddenInput.value = 'pickup:';
              }
          }
          miniHiddenInput.value =
          (miniSelectedRadio ? miniSelectedRadio.value + ":" : "") +
          miniNoteTextarea.value;
        var miniNoteValue = miniHiddenInput.value;
        var minilen = miniNoteTextarea.value.length;
        miniNoteLength.innerText = minilen;
        clearTimeout(miniDebounceTimer);
        miniDebounceTimer = setTimeout(
          function () {
            fetch("".concat(window.routes.cartUrl, "/update.js"), {
              body: JSON.stringify({
                note: miniNoteValue,
              }),
              credentials: "same-origin",
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
              },
            });
          }.bind(this),
          500
        ); // 500毫秒作为防抖延迟时间，你可以根据需要调整
      }

    }, 1000);
  });
  function enableAddToCartButton() {
    var checkbox = document.getElementById('checkbox-understand');
    var button = document.querySelector('.product-form__add-button');
    if (checkbox.checked) {
      button.disabled = false;
      button.classList.remove('button--disabled');
      button.classList.add('button--primary');
    } else {
      button.disabled = true;
      button.classList.add('button--disabled');
      button.classList.remove('button--primary');
  
    }
  }
  function showAlert(message, type, afterElement) {
    var messageElement = document.createElement("div");
    // make sure messageElement is unique
    messageElement.id = "product-form__status-message";
    if (document.getElementById("product-form__status-message")) {
      return;
    }
    messageElement.className = "product-form__status-message";
    messageElement.innerHTML = '<p class="alert '
      .concat(
        type === "success" ? "alert--success" : "alert--error",
        '">'
      )
      .concat(message, "</p>");
    afterElement.removeAttribute("disabled");
    afterElement.insertAdjacentElement(
      "afterend",
      messageElement
    );
    Animation.slideDown(messageElement);
    setTimeout(function () {
      Animation.slideUp(messageElement, function () {
        messageElement.remove();
      });
    }, 56500);
  }
mainProductAddToCart_fn = function(event2,that) {
  event2.preventDefault();
  event2.stopPropagation();
  event2.target.setAttribute("disabled", "disabled");
  document.dispatchEvent(new CustomEvent("theme:loading:start"));
  const formElement = event2.target.closest('form[action*="/cart/add"]');
  fetch(`${window.routes.cartAddUrl}.js`, {
    body: JSON.stringify(Form.serialize(formElement)),
    credentials: "same-origin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest"
      // This is needed as currently there is a bug in Shopify that assumes this header
    }
  }).then((response) => {
    event2.target.removeAttribute("disabled");
    let element = document.querySelector(".product-form__add-button");
    let sectionType = event2.target.closest("[data-section-type]")?.getAttribute("data-section-type");
    // if (sectionType === "product" || sectionType === "product-quick-view") {
    //   element = event2.target.closest(".product-form");
    // }
    if (!element) {
      element = document.body;
    }
    that.dispatchEvent(new CustomEvent("product:added", {
      bubbles: true,
      detail: {
        button: event2.target,
        variant: null,
        quantity: parseInt(formElement.querySelector('[name="quantity"]').value),
        productAdded: response.ok
      }
    }));
    if (response.ok) {
      if (theme.pageType === "cart" || window.theme.cartType === "page") {
        window.location.href = window.routes.cartUrl;
        return;
      }
      if (window.theme.cartType === "drawer") {
        document.dispatchEvent(new CustomEvent("modal:close"));
      }
      // if (window.theme.cartType === "message") {
      //   showAlert(window.languages.productAdded, "success", element);
      // }
      showAlert(window.languages.productAdded, "success", element);
    } else {
      response.json().then((content) => {
        __privateMethod(that, _BuyButton_instances, showAlert_fn).call(that, content["description"], "error", element);
      });
      document.dispatchEvent(new CustomEvent("theme:loading:end"));
    }
  });
  event2.preventDefault();
};
document.getElementById('product-form')?.querySelector('form[action^="/cart/add"]').addEventListener('submit', function(event) {
  event.preventDefault();
  event.stopPropagation();
  const el = document.getElementById('product-form')
  mainProductAddToCart_fn(event,el);
});
